import { Heading, NextImage, Text, Flex } from '@dapperlabs/core-fe';
import React from 'react';

interface Props {
  cardHeading: string;
  cardImgSrc: string;
  cardText: string;
}

export const HowMomentsCard: React.FC<Props> = ({
  cardHeading,
  cardText,
  cardImgSrc,
}) => {
  return (
    <Flex
      direction='column'
      flexBasis={['auto', 'auto', '35.75rem']}
      mb={[4, 0]}
    >
      <NextImage width={572} height={350} src={cardImgSrc} />
      <Heading as='h3' pt={['1rem', '1.5rem']} fontSize='1.125rem'>
        {cardHeading}
      </Heading>
      <Text pt={2} fontSize={['sm', 'sm', 'lg']}>
        {cardText}
      </Text>
    </Flex>
  );
};
